export enum ThemeObjectType {
  TOPBAR = 'topBar',
  TOPBAR_TEXT = 'topBarText',
  LOGO = 'logo',
  BUTTON_COLOR = 'buttonColor',
  BUTTON_TEXT = 'buttonText',
}
